import {PageData} from '@github-ui/pull-request-page-data-tooling/page-data'
import {reactFetch} from '@github-ui/verified-fetch'
import type {FilesRoutePayload} from '../payloads/files'
import {useQuery, type QueryKey} from '@github-ui/react-query'

interface QueryKeyFields {
  basePath: string
  selectedRange: {
    baseOid: string
    headOid: string
  }
}

export function diffComparisonDataKey({basePath, selectedRange}: QueryKeyFields): QueryKey {
  return [PageData.baseComparisonInfo, basePath, `baseOid:${selectedRange.baseOid}`, `headOid:${selectedRange.headOid}`]
}
/**
 * Fetches the files route payload info for a given PR
 */
export function useDiffComparisonData({
  basePath,
  headSha,
  baseSha,
  shouldFetch,
}: {
  basePath: string
  headSha: string
  baseSha?: string
  shouldFetch: boolean
}) {
  const params = new URLSearchParams()
  if (baseSha === headSha) {
    params.append('range', headSha ?? '')
  } else if (baseSha && headSha) {
    params.append('range', `${baseSha}..${headSha}`)
  } else if (headSha) {
    params.append('range', headSha)
  }
  const baseFetchUrl = `${basePath}/page_data/${PageData.baseComparisonInfo}?${params.toString()}`
  const queryKey = diffComparisonDataKey({
    basePath,
    selectedRange: {
      baseOid: baseSha ?? 'base-sha-not-provided',
      headOid: headSha,
    },
  })
  return useQuery<FilesRoutePayload | undefined>({
    queryKey,
    queryFn: async () => {
      if (!headSha) return undefined
      const result = await reactFetch(baseFetchUrl)
      if (!result.ok) throw new Error(`HTTP ${result.status}`)
      const json = await result.json()
      return json ?? undefined
    },
    staleTime: Infinity,
    enabled: shouldFetch,
  })
}
